import jsonTool from '../util/jsontool';
/**
 * 是否可以直接输出的日志类型，例如string类型可以直接输出（而不需要stringify）
 */
function checkDirectLogType(logValue) {
    return ['string', 'number', 'bigint', 'boolean', 'symbol', 'undefined'].indexOf(typeof logValue) !== -1;
}
/**
 * 将logger.log(a, b, c)中的参数列表进行参数序列化。
 * （没有直接用json.stringify是避免打印出现较多无效字符，例如被[]和""包裹的情况）
 */
export function stringifyLogArgs(args, ignoreKeyList) {
    if (ignoreKeyList === void 0) { ignoreKeyList = []; }
    var argStrArr = [];
    if (args) {
        argStrArr = args.map(function (arg) {
            if (checkDirectLogType(arg)) {
                // 直接输出
                return arg;
            }
            return stringifyLog(arg, ignoreKeyList);
        });
    }
    return argStrArr.join(' ');
}
/**
 * 序列化日志数据为字符串
 */
export function stringifyLog(data, ignoreKeyList) {
    if (ignoreKeyList === void 0) { ignoreKeyList = []; }
    return jsonTool.safelyStringify(data, function (key, logValue) {
        if (ignoreKeyList.indexOf(key) !== -1) {
            // 如果打印的key在黑名单，不打印
            return '';
        }
        if (!logValue || logValue instanceof Array || checkDirectLogType(logValue)) {
            return logValue;
        }
        if (typeof logValue === 'function') {
            // 函数不要转换成真实函数字符串
            return '[function]';
        }
        if (logValue.constructor !== Object) {
            // 仅{}和new Object()可以被JSON.stringify展开
            return "".concat(logValue);
        }
        return logValue;
    });
}
/**
 * 下载日志txt文本
 */
export function dumpLog(data) {
    var element = document.createElement('a');
    var output = data.join('\n\n');
    element.setAttribute('href', "data:text/plain;charset=utf-8,".concat(encodeURIComponent(output)));
    element.setAttribute('download', "tp-log-".concat(Date.now(), ".txt"));
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
;
export function getLogTime() {
    var time = new Date();
    var timeStr = "".concat(time.getHours(), ":").concat(time.getMinutes(), ":").concat(time.getSeconds())
        + ".".concat(("0000".concat(time.getMilliseconds())).slice(-3));
    return timeStr;
}
